const icons = [
  'chart-line',
  'clipboard-check',
  'users',
  'tasks',
  'file-alt',
  'calendar-check',
  'database',
  'cogs',
  'bullseye',
  'project-diagram',
  'check-circle',
  'exclamation-triangle',
  'flag',
  'clock',
  'question-circle',
  'book',
  'sync-alt',
  'lightbulb',
  'chart-pie'
];

export default icons;